import BottomSection from "./components/BottomSection";
import Toolbox from "./components/Toolbox";
import TopSection from "./scenes/employee/components/TopSection";
import "./main.scss";
import Header from "Dashboard/components/Header";

const HumanResources = () => {
  return (
    <>
      <Header title="Ljudski resursi" />
      <Toolbox />
      <main id="human-resources">
        <TopSection />
        <BottomSection />
      </main>
    </>
  );
};

export default HumanResources;
